import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import { isValid, parseISO } from "date-fns";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatDateForTransaction } from "@helpers/date";
import { CatalogItemPriceRow } from "../catalogItemPrices.types";

export function getCatalogItemPriceCreatedOnLabel(
    price: CatalogItemPriceRow,
): string | null {
    if (price.isDraft || price.isStaged) {
        return null;
    }
    const createdAt =
        typeof price.createdAt === "string"
            ? parseISO(price.createdAt)
            : price.createdAt;
    if (!createdAt || !isValid(createdAt) || createdAt.getTime() === 0) {
        return null;
    }
    return formatDateForTransaction(createdAt);
}

export const PriceCreatedOnCell = memo(function PriceCreatedOnCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemPriceRow, unknown>) {
    const label = getCatalogItemPriceCreatedOnLabel(row.original);
    return <ViewTableCell>{label}</ViewTableCell>;
});
